import React, { PropsWithChildren } from 'react';
import { futureDate, zeroHourISOString, finalHourISOString, passDate } from '@components/Utils';

interface ServicesContextInterface {
  updateRange: (from: string, to: string) => void;
  from: string;
  to: string;
}

interface ProviderState {
  from: string;
  to: string;
  timezone?: string;
}

interface ServicesProviderProps {
  from?: string;
  to?: string;
}

export const ServicesContext = React.createContext<ServicesContextInterface>(
  {} as ServicesContextInterface
);

export const ServicesProvider: React.FC<PropsWithChildren<ServicesProviderProps>> = ({
  children,
  from = zeroHourISOString(futureDate(0)),
  to = finalHourISOString(futureDate(21)),
}) => {
  const [state, setState] = React.useState<ProviderState>({
    from,
    to,
  });

  const updateRange = (from: string, to: string): void => setState({ from, to });

  const value = {
    updateRange,
    from: state.from,
    to: state.to,
  };

  return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>;
};

export const useServicesContext = (): ServicesContextInterface => {
  const context = React.useContext(ServicesContext);
  return context;
};

interface AnalyticsOverviewContextInterface {
  updateRange: (from: string, to: string) => void;
  from: string;
  to: string;
}

// ---------------------------------------------------------------------------------------- //

interface AnalyticsOverviewProviderProps {
  from?: string;
  to?: string;
}

export const AnalyticsOverviewContext = React.createContext<AnalyticsOverviewContextInterface>(
  {} as AnalyticsOverviewContextInterface
);

export const AnalyticsOverviewProvider: React.FC<
  PropsWithChildren<AnalyticsOverviewProviderProps>
> = ({
  children,
  from = zeroHourISOString(passDate(28)),
  to = finalHourISOString(passDate(0)),
}) => {
  const [state, setState] = React.useState<ProviderState>({
    from,
    to,
  });

  const updateRange = (f: string, t: string): void => setState({ from: f, to: t });

  const value = {
    updateRange,
    from: state.from,
    to: state.to,
  };

  return (
    <AnalyticsOverviewContext.Provider value={value}>{children}</AnalyticsOverviewContext.Provider>
  );
};

export const useAnalyticsOverviewContext = (): AnalyticsOverviewContextInterface => {
  const context = React.useContext(AnalyticsOverviewContext);
  return context;
};
